import React, { useState, useEffect } from 'react';
import { Button } from '@rmwc/button';
import '@rmwc/button/styles';
import { Snackbar } from '@rmwc/snackbar';
import '@rmwc/snackbar/styles';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

function ResetDB() {
  const setLänge = useFlexionStore((state) => state.setLänge);
  const setPunktlast = useFlexionStore((state) => state.setPunktlast);
  const setStreckenlast = useFlexionStore((state) => state.setStreckenlast);
  const setb = useFlexionStore((state) => state.setb);
  const setMt = useFlexionStore((state) => state.setMt);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [open, setopen] = useState(false);
  const [text, settext] = useState(getText(Sprache));

  function reset() {
    setopen(!open);
    setLänge(0);
    setPunktlast(0);
    setStreckenlast(0);
    setb(0);
    setMt(0);
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <>
      <Snackbar
        open={open}
        message={text.Reset.Msg}
        timeout={1500}
        onClose={() => setopen(!open)}
      />
      <Button className='ResetButton' onClick={reset}>
        Reset
      </Button>
    </>
  );
}

export default ResetDB;
